const SAMPLE_LABEL_PREFIX: Record<string, string> = {
  da: 'P',
  en: 'P',
  de: 'P',
}

const DEFAULT_SAMPLE_LABEL_PREFIX = 'P'

export function getSampleLabel(sampleNumber: number, locale: string): string {
  const prefix = SAMPLE_LABEL_PREFIX[locale] ?? DEFAULT_SAMPLE_LABEL_PREFIX
  return `${prefix}${sampleNumber}`
}
